import { type Models } from 'node-appwrite'
import { type DeploymentStatusType } from '@/lib/deployment-status'
import z from 'zod'

export const llmEnum = z.enum([
  'anthropic/claude-opus-4-5',
  'openai/gpt-5.2',
])

export type TLlmModel = z.infer<typeof llmEnum>

export type Deployments = Models.Row & {
  createdBy: string
  name: string
  status: DeploymentStatusType
  region: string
  machineType: string
  llmModel: TLlmModel
  apiKey?: string // OpenRouter API key for usage tracking
  usageCount: number
  usageLimit: number
  telegramToken: string | null
  selectedChannel: string | null
  createdAt: number
  sshPublicKey?: string
  sshPrivateKey?: string
  sshUsername?: string
  ip?: string
  lastSyncedUsd?: number
  lastServerCostDeductedAt?: number
}

export type Integrations = Models.Row & {
  createdBy: string
  deploymentId: string
  integrationType: string
  botUsername: string | null
  botToken: string | null
  webhookUrl: string | null
  channelId: string | null
  isActive: boolean
  configData: string | null
}

export type Profiles = Models.Row & {
  userId: string
  plan: 'starter' | 'pro' | 'business' | 'free'
  credits: number
  subscriptionId: string | null
  lastRefillAt: number
}
